import {useForm} from 'react-hook-form'

import Button from '@mui/material/Button'
import PropTypes from 'prop-types'

import FormWrapper from '../../shared/FormWrapper'
import Modal from '../../shared/Modal'
import OtpInput from '../../shared/OtpInput'

const VerifyEmail = props => {
  const methods = useForm({defaultValues: {code: ''}})

  const close = () => {
    methods.reset()
    props.handleClose()
  }

  // A code that has expired and a code that was mistyped come back as the same refusal, and from
  // here they call for the same thing anyway: type it again, or start the address over.
  const handleSubmit = ({code}) => {
    props.verifyEmail({email: props.email, code}).then(response => {
      if (response.success)
        close()
      else
        methods.setError('code', {type: 'server', message: "That code doesn't match, or it has expired"})
    })
  }

  return (
    <Modal
      maxWidth='sm'
      open={props.open}
      handleClose={close}
      buttonText='Close'
      subHeading='Enter the 6-digit code we sent there. It expires an hour after it was sent.'
      title={`Verify ${props.email.address}`}>
      <FormWrapper methods={methods} handleSubmit={handleSubmit}>
        <OtpInput control={methods.control} autoFocus />
        <Button disabled={props.loading} type='submit' variant='contained'>Verify</Button>
      </FormWrapper>
    </Modal>
  )
}

VerifyEmail.propTypes = {
  email: PropTypes.object.isRequired,
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  verifyEmail: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default VerifyEmail
